import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  containerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10
  },
  containerColumn: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10
  },
  mainContainer: {
    padding: 10,
    borderRadius: 30,
    marginRight: 10,
    marginLeft: 10,
    backgroundColor: '#f3f4f6',
    justifyContent: 'space-between',
  },
  pastille: {
    borderRadius: '100%',
    height: 40,
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2
  },
  sectionHeader: {
    backgroundColor: '#f8fafc',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0'
  },
  sectionHeaderText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#374151'
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
    paddingHorizontal: 20
  },
  emptyTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#6b7280',
    marginTop: 16,
    textAlign: 'center'
  },
  emptySubtitle: {
    fontSize: 16,
    color: '#9ca3af',
    marginTop: 8,
    textAlign: 'center',
    lineHeight: 22
  },
  statusBadge: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 1,
    paddingVertical: 1,
    borderRadius: '100%',
  },
  headerAgenda: {
    flexDirection: 'row',
    paddingLeft: 35,
    paddingRight: 35,
    paddingTop: 15,
    justifyContent: 'space-between',
    backgroundColor:'white'
  },
})

export default styles
